import { camelCaseObject, getConfig } from '@edx/frontend-platform';
import { getAuthenticatedHttpClient } from '@edx/frontend-platform/auth';

import type { ContentLibrary } from '../../data/api';

const getApiBaseUrl = () => getConfig().STUDIO_BASE_URL;

/**
 * Get the URL for creating a legacy library (v1).
 */
export const getContentLibraryV1CreateApiUrl = () => `${getApiBaseUrl()}/library/`;

export interface CreateContentLibraryArgs {
  title: string,
  org: string,
  slug: string,
}

/**
 * Create a new library using the legacy v1 API.
 */
export async function createLibraryV1(data: CreateContentLibraryArgs): Promise<ContentLibrary> {
  const client = getAuthenticatedHttpClient();
  const url = getContentLibraryV1CreateApiUrl();

  const payload = {
    display_name: data.title,
    org: data.org,
    library: data.slug,
  };

  const { data: newLibrary } = await client.post(url, payload);
  return camelCaseObject(newLibrary);
}
